<template>

    <div class="person-result-main">
      <!-- 模板上部分 -->
      <span class="person-userName">{{resultData.data[0].userName}}</span>
      <span class="person-num">{{resultData.data[0].certNo}}</span>
      <span class="person-certName">{{resultData.data[0].certName.substring(0,1)}}</span>
      <span class="person-mark">{{resultData.data[0].mark}}</span>

      <span class="b-y bir">{{initData(1,1)}}</span>
      <span class="b-m bir">{{initData(2,1)}}</span>
      <span class="b-d bir">{{initData(3,1)}}</span>
      <span class="c-y cate">{{initData(1,2)}}</span>
      <span class="c-m cate">{{initData(2,2)}}</span>
      <span class="c-d cate">{{initData(3,2)}}</span>
      <!-- <span class="person-data">{{formatDate(resultData.data[0].issueTime)}}</span> -->
      <!-- <span class="issueTime"></span> -->
      <!-- 模板下部分 -->
      <span class="person-userName person-userName-e ">{{resultData.data[0].userNameLetter}}</span>
      <span class="person-num person-num-e">{{resultData.data[0].certNo}}</span>
      <span class="person-birth-e">{{getAnalysisIdCard(resultData.data[0].idNo,1)}}</span>
      <span class="nationality">CHINA</span>
      <span class="person-certName-e">{{resultData.data[0].certName.substring(0,1)}}</span>
      <span class="person-mark-e">{{resultData.data[0].mark}}</span>
    </div>

</template>

<script>
// import { modifiedPwd } from '@/api/association'
import {formatDate} from '@/components/common/config/formatTime.js'
// import md5 from 'js-md5'
export default {
  name: '',
  components: {
  },
  data () {
    return {
      current: null,
      loading: false,
      b_y: '',
      b_m: '',
      b_d: '',
      certificateNumStr: '',
      type: this.$route.params.type,
      currentPage: 1,
      assoUserInfo: JSON.parse(localStorage.getItem('assoUserInfo')),
      titleMsg: '个人信息',
      resultData: JSON.parse(localStorage.getItem('referResultData'))
    }
  },
  methods: {
    formatDate,
    initData (num, type) {
      if (type === 1) {
        let ymd = this.getAnalysisIdCard(this.resultData.data[0].idNo, 1)
        console.log(ymd)
        if (num === 1) {
          return ymd.split('-')[0]
        } else if (num === 2) {
          return ymd.split('-')[1]
        } else if (num === 3) {
          return ymd.split('-')[2]
        }
      } else if (type === 2) {
        let ymd = this.formatDate(this.resultData.data[0].issueTime)
        console.log(ymd)
        if (num === 1) {
          return ymd.split('-')[0]
        } else if (num === 2) {
          return ymd.split('-')[1]
        } else if (num === 3) {
          return ymd.split('-')[2]
        }
      }
    },
    getAnalysisIdCard (card, num) {
      if (num === 1) {
      // 获取出生日期
        let birth = card.substring(6, 10) + '-' + card.substring(10, 12) + '-' + card.substring(12, 14)
        return birth
      }
      if (num === 2) {
      // 获取性别
        if (parseInt(card.substr(16, 1)) % 2 === 1) {
        // 男
          return '男'
        } else {
        // 女
          return '女'
        }
      }
      if (num === 3) {
      // 获取年龄
        var myDate = new Date()
        var month = myDate.getMonth() + 1
        var day = myDate.getDate()
        var age = myDate.getFullYear() - card.substring(6, 10) - 1
        if ((card.substring(10, 12) < month || card.substring(10, 12) === month) && card.substring(12, 14) <= day) {
          age++
        }
        return age
      }
    },
    backGetCertificate (type) {
      localStorage.removeItem('referResultData')
      this.$router.push({
        path: '/PersonInfo',
        query: { flag: type }
      })
    },
    getStatusFun () {
      if (this.assoUserInfo.status === 0) {
        return '待审核'
      } else if (this.assoUserInfo.status === 1) {
        return '审核通过 '
      } else if (this.assoUserInfo.status === 2) {
        return '驳回'
      }
    }

  },
  mounted () { // 这里必须是mouted钩子
    // 下拉加载更多监听滚轮
    // window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮 滚动事件
  },
  created () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .person-result-main{
    width: 437px;
    height: 565px;
    margin: 0px auto;
    /* padding-bottom: 100px; */
    background: url(/static/images/refercert-bg2.jpg) 0px 0px no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  .result-item{
    overflow: hidden;
    margin-bottom: 10px;
    /* background: url(/static/images/icon-right.png) right center no-repeat; */
  }
  .person-num{
    position: absolute;
    top: 99px;
    left: 105px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;

  }
  .person-userName{
    position: absolute;
    top: 142px;
    left: 153px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .person-mark{
    position: absolute;
    top: 130px;
    left: 220px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .person-certName-e{
    position: absolute;
    top: 326px;
    left: 150px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .person-mark-e{
    position: absolute;
    top: 326px;
    left: 230px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .person-userName-e{
    top: 305px;
    left: 160px;
  }
  .person-num-e{
    top: 284px;
    left: 120px;
  }
  .nationality{
    position: absolute;
    top: 296px;
    left: 160px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .person-birth-e{
    position: absolute;
    top: 318px;
    left: 160px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .person-certName{
    position: absolute;
    top: 130px;
    left: 153px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .person-data{
    position: absolute;
    top: 252px;
    left: 182px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .issueTime{
    position: absolute;
    top: 434px;
    left: 163px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .bir{
    position: absolute;
    top: 155px;
    left: 163px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .b-y{
    left: 173px;
  }
  .b-m{
    left: 220px;
  }
  .b-d{
    left: 248px;
  }
  .cate{
    position: absolute;
    top: 208px;
    left: 163px;
    font-size: 12px;
    font-weight: bold;
    color:#cc0000;
  }
  .c-y{
    left: 173px;
  }
  .c-m{
    left: 220px;
  }
  .c-d{
    left: 248px;
  }
  .result-item-left{
    float: left;
    width: 80px;
    padding: 5px 0px;
    font-size: 14px;
  }
  .result-item-right{
    float: left;
    background: #fff;
    width: 300px;
    padding: 5px;
    font-size: 14px;
    border-radius: 5px;
  }
  .certificate-nav{
    float: left;
    width: 100%;
  }
  .person-text-title{
    padding: 30px 0px;
    text-align: center
  }
  .person-text-title span{
    background: url(/static/images/ge-ren.png)0px center no-repeat;
    background-size: 20px 20px;
    padding: 10px 0px 10px 25px;
    font-size: 16px;
  }
  .check-nav{
    padding-top:10px;
    width: 400px;
    margin: 0px auto;
  }
  .check-nav .submit-btn{
    width: 100%;
    text-align: center;
  }
  .check-nav .el-input{
    margin-bottom: 20px;
    text-align: center
  }
  .check-nav .submit-btn .el-button{
    background: #cc0000;
    color: #fff;
    border-color: #cc0000;
    padding: 10px 20px;
  }
  .personal-certificate .seach{
    width: 100%;
    margin-bottom: 5px;
  }
  .personal-certificate .seach .el-input{
    width: 300px;
  }
  .personal-certificate .el-button{
    background: #cc0000;
    color: #fff;
  }
  .right-main{
    width: 815px;
    margin-left: 20px;
    background: #fff;
    float: right;
    height: 616px;
    padding: 0px 50px;
    border-radius: 10px;
  }
  .right-title{
    font-size: 16px;
    text-align: center;
    color:#666;
    margin-top: 50px;
  }
  .right-item{
    border-bottom: 1px solid #eee;
    padding: 15px 0px;
    overflow: hidden;
    color:#666;
    font-size: 14px;
    line-height: 30px;
    background: url(/static/images/icon-right.png) 0px center no-repeat;
  }
  .right-item .user-name{
    float: left;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 25px 27px;
    background-size: 25px 27px;
    padding-left: 30px;
    margin-left: 40px;
    width: 100px;
  }
  .submit-btn{
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .submit-btn .el-button{
    background: #cc0000;
    color: #fff;
    border-color: #cc0000;
    padding: 10px 20px;
  }
  .showPass{
    font-size: 14px;
    border: none;
    background: none;
    outline:none;
    margin-left: 100px;
  }
  input:focus {
    border: none
  }
  .right-item .icon-name{
    background-image: url(/static/images/login-user.png);
  }
  .right-item .icon-pass{
    background-image: url(/static/images/login-pass.png);
  }
  .right-item .icon-user{
    background-image: url(/static/images/icon-tuanti.png);
  }
  .right-item .icon-state{
    background-image: url(/static/images/icon-state.png);
  }
  .right-item .begin-time{
    background-image: url(/static/images/begin-time.png);
  }
  .right-item .end-time{
    background-image: url(/static/images/end-time.png);
  }
  .right-item .name-text{
    float: left;
    margin-left: 100px;
  }
  .right-item .updata{
    float:right;
    padding:0px 10px;
    cursor: pointer;
  }
  .submit{
    padding-top: 50px;
    text-align: center;
  }
  .submit span{
    padding: 10px 50px;
    background: #cc0000;
    border-radius:5px;
    color: #fff;
    cursor: pointer;
  }
  .fixd {
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    z-index: 99999;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/UserCenter/CateTemplate.vue